import React, { useState } from 'react';
import { SearchOutlined } from '@ant-design/icons';
import { Table, Tooltip, Radio, Select, Col, Row, Space, Pagination, Input, Modal, Checkbox, Button } from 'antd';

const { Option } = Select;

const MultipleSelect = () => {
    const [searchValue, setSearchValue] = useState('');
    const [filterApply, setFilterApply] = useState({
        publisher: [],
    });

    const options = [
        { value: 'jack1', label: 'Jack 1' },
        { value: 'lucy1', label: 'Lucy 1' },
        { value: 'lucy8', label: 'Lucy 8' },
        { value: 'tom8', label: 'Tom 8' },
        { value: 'jack9', label: 'Jack 9' },
        { value: 'lucy9', label: 'Lucy 9' },
        { value: 'tom9', label: 'Tom 9' },
    ];

    const handleSearch = (e) => {
        setSearchValue(e.target.value.toLowerCase());
    };

    const onChange = (value) => {
        console.log(`Selected: ${value}`);
    };

    const handleFilterApply = (type, value) => {
        setFilterApply((prev) => {
            const currentPublishers = prev.publisher;
            const isSelected = currentPublishers.includes(value);

            // Toggle selection
            const updatedPublishers = isSelected
                ? currentPublishers.filter((item) => item !== value)
                : [...currentPublishers, value];

            return { ...prev, publisher: updatedPublishers };
        });
    };

    // Filtering options based on search input
    const filteredOptions = options.filter((option) =>
        option.label.toLowerCase().includes(searchValue)
    );

    return (
        <div style={{ marginTop: '300px' }}>
            <Row>
                <Col span={16}>
                    <div className="container_box--form-container ">
                        <div className="form_content_block--group">
                            <div className='checkbox_value_select_d2 multi_select_tag_d2'>
                                <label className="form_label">Seat List Mode </label>
                                <Select
                                    id="adcodeSelect"
                                    value={filterApply.publisher}
                                    popupClassName='diff_select_d2'
                                    // open={true}
                                    showSearch={false}
                                    placeholder='- Select -'
                                    className="form_select basic"
                                    mode='multiple'
                                    maxTagCount='responsive'
                                    dropdownRender={menu => (
                                        <>
                                            <div className="custom_inside_searchbar_d2">
                                                <Input placeholder="Search" value={searchValue} onChange={handleSearch} prefix={<SearchOutlined className="search_icon_d2" />} allowClear />
                                            </div>
                                            {menu}
                                        </>
                                    )}
                                >
                                    {filteredOptions.map(option => (
                                        <Option key={option.value} value={option.value}>
                                            <div
                                                onClick={() => handleFilterApply("publisher", option.value)}
                                                style={{ display: 'flex', alignItems: 'center' }}
                                            >
                                                <Checkbox
                                                    checked={filterApply.publisher.includes(option.value)}
                                                    onClick={(e) => e.stopPropagation()}
                                                >
                                                    {option.label}
                                                </Checkbox>
                                            </div>
                                        </Option>
                                    ))}
                                </Select>
                            </div>
                        </div>
                    </div>
                </Col>
            </Row>
        </div >
    );
};

export default MultipleSelect;
